const AdminDashboard = () => import('@/views/tableau-de-bord/dashboard-admin')
const InfirmierDashboard = () => import('@/views/tableau-de-bord/dashboard-infirmier')
const MedecinDashboard = () => import('@/views/tableau-de-bord/dashboard-medecin')
const LaboratinDashboard = () => import('@/views/tableau-de-bord/dashboard-laboratin')
const MdtDashboard = () => import('@/views/tableau-de-bord/dashboard-mdt')
const SageFemmeDashboard = () => import('@/modules/sage-femme/Dashboard.vue')

export default {
    name: 'tableau-de-bord',
    components: {
        AdminDashboard,
        InfirmierDashboard,
        MedecinDashboard,
        LaboratinDashboard,
        MdtDashboard,
        SageFemmeDashboard
    },
    props: [],
    data() {
        return {
            user_role: '',
            active_role: '',
        }
    },
    
    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },
    },
    mounted() {
        if (this.userCredentials.roles.length > 0) {
            this.user_role = this.userCredentials.roles[0].nom;
        }

        if (this.activeRole.nom == 'ROLE_TECHNICIEN_IMAGERIE' || this.activeRole.nom == 'ROLE_RADIOLOGUE') {
            this.$router.push({ path: '/examens/porter-resultat' });
        }

        this.active_role = this.activeRole.nom
    },

    methods: {

    }
}
